<form class="typeahead-form">
  <div class="search-container">
    <input
      #searchInput
      class="typeahead-search"
      type="text"
      placeholder="{{ placeholderText }}"
      [formControl]="search"
      [matAutocomplete]="auto"
    />
    <capra-icon class="typeahead-icon" [class.close-icon]="icon === 'icon-close'" [icon]="icon" (click)="onIconClick()">
    </capra-icon>
  </div>
  <mat-autocomplete
    #auto="matAutocomplete"
    class="typeahead-autocomplete"
    (optionSelected)="onOptionSelected($event)"
    (opened)="onTypeaheadMenuOpened()"
  >
    <mat-option class="attr-list no-results" *ngIf="(filteredOptions$ | async).length === 0">
      No fields to display.
    </mat-option>
    <mat-option
      class="attr-list"
      *ngFor="let attr of filteredOptions$ | async; trackBy: trackByName"
      [value]="attr.attr.attrName"
    >
      <capra-icon [ngClass]="attr.discrete ? 'attr-discrete' : 'attr-continuous'" [icon]="attr.icon"></capra-icon>
      <span class="attr-name">{{ attr.attr.attrName }}</span>
    </mat-option>
  </mat-autocomplete>
</form>
